<template>
    <a
            href="#"
            :id="id_name"
            @click="generate_excel">
        <slot>
            {{button_text}}
        </slot>
    </a>
</template>

<script lang="babel">
  export default {
    data: function () {
      return {
        animate: true,
        animation: ''
      }
    },
    props: {
      'button_text': {
        type: String,
        default: 'Download Excel'
      },
      'data': {
        type: Array,
        required: true
      },
      'fields1': {
        type: Object
      },
      'fields2': {
        type: Array,
        required: true
      },

      'name': {
        type: String,
        default: 'data.xls'
      }
    },
    created: function () {
    },
    computed: {
      id_name: function () {
        var now = new Date().getTime()
        return 'export_' + now
      }
    },
    methods: {
      emitXmlHeader: function () {
        var headerRow1 = ''
        if (this.fields1 !== undefined) {
          headerRow1 = '<tr  >\n'
          for (var colName in this.fields1) {
            headerRow1 += '  <th   colspan="' + this.fields1[colName] + '">\n'
            headerRow1 += colName + '\n'
            headerRow1 += '  </th>\n'
          }
          headerRow1 += '</tr>\n'
        }
        var headerRow2 = '<tr >\n'
        for (var ind in this.fields2) {
          headerRow2 += '  <th>\n'
          headerRow2 += this.fields2[ind] + '\n'
          headerRow2 += '  </th>\n'
        }
        headerRow2 += '</tr>\n'
        var style = '<style></style>'
        return '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' + style + '</head><body><table>\n' +
          '<thead>\n\n' +
          headerRow1 +
          headerRow2 +
          '</thead>\n\n' +
          '</tbody>\n'
      },
      emitXmlFooter: function () {
        return '\n</tbody>\n' +
          '</table>\n' +
          '</body>\n' +
          '</html>\n'
      },
      jsonToHtml: function (jsonObject) {
        var row
        var col
        var xml
        var data = typeof jsonObject !== 'object'
          ? JSON.parse(jsonObject)
          : jsonObject
        xml = this.emitXmlHeader()
        for (row = 0; row < data.length; row++) {
          xml += '<tr>\n'
          for (col in data[row]) {
            xml += '  <td>\n'
            xml += String(data[row][col]) + '\n'
            xml += '  </td>\n'
          }
          xml += '</tr>\n'
        }
        xml += this.emitXmlFooter()
        return xml
      },
      generate_excel: function () {
        this.$emit('onPrepareExportData')
        this.$nextTick(() => {
          let uri = 'data:application/vnd.ms-excel;base64,'
          let base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
          let a = document.getElementById(this.id_name)
          a.href = uri + base64(this.jsonToHtml(this.data))
          a.download = this.name
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// JsonExcel.vue?275dab3c